export default {
  // mac地址自定义验证
  checkMac: (rule, value, callback) => {
    const reg = new RegExp('[0-9a-fA-F]{2}(:[0-9a-fA-F]{2}){5}');
    if (!reg.test(value)) {
      callback(new Error('请输入正确的Mac地址：xx:xx:xx:xx:xx:xx'));
    } else {
      callback();
    }
  },

  // 手机号码自定义验证
  checkPhone: (rule, value, callback) => {
    const reg = new RegExp('^1[1-9][0-9]{9}$');
    if (!reg.test(value)) {
      callback(new Error('手机号格式不正确'));
    } else {
      callback();
    }
  },

  // 汉字姓名验证
  checkName: (rule, value, callback) => {
    const reg = new RegExp('^[\u4e00-\u9fa5]{2,}$');
    if (!reg.test(value)) {
      callback(new Error('姓名输入格式不正确'));
    } else {
      callback();
    }
  },

  // 地址验证
  checkAddress: (rule, value, callback) => {
    if (!value[0]) callback(new Error('省份不能为空'));
    // if(!value[1]) callback(new Error('市名不能为空'));
    // if(!value[2]) callback(new Error('县区不能为空'));
    callback();
  },

  // ip 检查
  checkIp: (rule, value, callback) => {
    const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/g;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error('ip地址格式不正确'));
    }
  },
};




// WEBPACK FOOTER //
// ./src/utils/rules/customRegular.js